import {
  Popover,
  type PopoverDropdownProps,
} from '@mantine/core'
import { useClickOutside } from '@mantine/hooks'
import { useContext } from 'react'

import { PopoverTrackedContext } from './PopoverTrackedContext'
import { usePopoverTrackedState } from './usePopoverTrackedState'
import { type UNSAFE_any } from '@flecto/types'

export type PopoverTrackedDropdownParams = PopoverDropdownProps

export function PopoverTrackedDropdown({
  children,
  ...props
}: PopoverTrackedDropdownParams) {
  const handleClickOutside = ((
    event: UNSAFE_any
  ) => {
    if (!event?.target) return;
    const target = event.target as Node;
    if (refClickOutside.current?.contains(target)) return;
    setPopoverIdOpened(null);
  }) as () => void;
  
  const refClickOutside = useClickOutside(handleClickOutside);
  
  const { setPopoverIdOpened } = usePopoverTrackedState()
  const context = useContext(PopoverTrackedContext)

  if (!context) return null
  const { height, width, position, handleClose, handleMove} = context

  return (
    <Popover.Dropdown
      {...props}
      ref={refClickOutside}
      w={width}
      h={height}
      onMouseEnter={() => {
          handleMove.clear()
          handleClose.clear()
      }}
      onMouseLeave={() => {
          handleMove.clear()
          handleClose.start()
      }}
      onMouseMoveCapture={() => {
          handleMove.clear()
          handleClose.clear()
      }}
      style={{
        bottom: position.bottom,
        left: position.left,
        position: 'fixed',
        right: position.right,
        top: position.top,
        zIndex: 9999,
      }}
    >
      {children}
    </Popover.Dropdown>
  )
}
